export const VISITED_DOWNLOAD_URL = '/advisor-service/advisors/iosDownload/status';
export const VISITED_DOWNLOAD = 'download/VISITED_DOWNLOAD';
export const VISITED_DOWNLOAD_SUCCESS = 'download/VISITED_DOWNLOAD_SUCCESS';
export const VISITED_DOWNLOAD_FAIL = 'download/VISITED_DOWNLOAD_SUCCESS';